var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.50511 0.337017C1.13401 0.0010352 0.563395 0.0323959 0.23061 0.407064C-0.102174 0.781732 -0.0711121 1.35783 0.29999 1.69381L5.25657 6.28585C5.59944 6.59628 6.11882 6.59628 6.46169 6.28585L11.5334 1.58962C11.9045 1.25364 11.9355 0.67754 11.6027 0.302872C11.27 -0.0717954 10.6993 -0.103156 10.3282 0.232826L5.85913 4.38353L1.50511 0.337017Z","fill":"#1C2E45","fillOpacity":"0.6"}));
}

ArrowDown.defaultProps = {"width":"12","height":"7","viewBox":"0 0 12 7","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
